import { render, staticRenderFns } from "./WillPrice.vue?vue&type=template&id=7a2bca66&scoped=true&"
import script from "./WillPrice.vue?vue&type=script&lang=js&"
export * from "./WillPrice.vue?vue&type=script&lang=js&"
import style0 from "./WillPrice.vue?vue&type=style&index=0&id=7a2bca66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2bca66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
